
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./contexts/AuthContext";
import Navbar from "./components/feature/Navbar";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthProvider>
          <div className="min-h-screen bg-white">
            <Navbar />
            <AppRoutes />
          </div>
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
